import gql from 'graphql-tag'

export const queryTemplatesList = () => {
	return {
		query: gql`
			{
				templates: pdf_templates(order_by: { id: desc }) {
					id
					name
					organization {
						name
					}
					country
					conf_comercial_base {
						base
					}
					conf_contract_type {
						type
					}
					active
				}
			}
		`,
		update: data =>
			data.templates.map(item => ({
				id: item.id,
				name: item.name,
				country: item.country,
				organization: item.organization.name,
				comercial: item.conf_comercial_base.base,
				type: item.conf_contract_type.type,
				edit: true,
				active: item.active
			}))
	}
}
